import styled from "styled-components";

const FormGroup = styled.div`
  margin-top: 15px;
`;

export default FormGroup;
